import React, { useEffect } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';
import "./App.css";
import "./components/About.css";
import "./components/Home.css";
import "./components/Navbar.css";
import "./components/Skills.css";
import "./components/Contact.css";
import "./components/Work.css";
import "./components/Footer.css";

import Skills from "./components/Skills";
import NavigationBar from "./components/Navbar";
import Home from "./components/Home";
import { BrowserRouter } from "react-router-dom";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Work from "./components/Work";

const App = () => {
  useEffect(() => {
    AOS.init({ duration: 1000,once: true });
  }, []);
  return (
    <BrowserRouter>
      <div className="app">
        <NavigationBar />

        <Home />
        <About />
        <Skills />
        <Work />
        <Contact />
        <Footer />
      </div>
    </BrowserRouter>
  );
};

export default App;
